<template>
  <div
    class="d-flex flex-column min-vh-100 vh-100"
    data-spy="scroll"
    data-target="#mainNav"
    data-offset="75"
  >
    <navigation-main />

    <div class="main-content">
      <main role="main" class="flex-grow-1 overflow-auto">
        <div id="content">
          <section class="page-section">
            <div class="container">
              <v-card class="mx-auto my-12" max-width="374">
                <form @submit.prevent="handleSubmit">
                  <v-card-title>
                    Forgotten Username?
                  </v-card-title>
                  <v-card-text>
                    <div class="form-group" v-if="!submitted">
                      <label for="email">E-Mail</label>
                      <input
                        type="email"
                        v-model="email"
                        name="email"
                        class="form-control"
                      />
                    </div>
                    <div v-if="submitted">
                      Your username has been sent to your e-mail address.
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <button
                      class="btn btn-primary w-75"
                      style="margin:auto"
                      v-if="!submitted"
                    >
                      Send Username
                    </button>

                    <button
                      class="btn btn-primary w-75"
                      style="margin:auto"
                      @click="$router.push('/login')"
                      v-if="submitted"
                    >
                      Login
                    </button>
                  </v-card-actions>
                </form>
              </v-card>
            </div>
          </section>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import NavigationMain from "@/views/navigation/navigation-main";

export default {
  components: { NavigationMain },
  data() {
    return {
      email: "",
      submitted: false
    };
  },
  computed: {
    ...mapState("api", ["status"])
  },
  methods: {
    ...mapActions("api", [
      "requestUsername",
      "handleRequestError",
      "printAlertMessage"
    ]),
    reset() {
      this.username = "";
    },
    handleSubmit() {
      this.requestUsername(this.email)
        .then(() => (this.submitted = true))
        .catch(this.handleRequestError);
    }
  }
};
</script>
